(function($) {  
  $(document).ready(function() {
    collection.init();
  }); 

  if ($(".collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {        
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }


  var collection = { 
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

      /* Collection Sorting */
      this.initCollectionSorting();

      /* Collection Show */
      this.initCollectionShow();

      /* Collection ViewMode */     
      this.initCollectionViewMode();

      /* Paging */
//       this.initPaging();

    },


    /* --------------------------------------------------------- */
    

    /* Hide Dropdown */
    initToggle: function(){
      $('.caret').click(function() {        
        $(this).parent().next().toggleClass('active');        
        return false; 
      }); 

      $(".block-category .sub-menu > li").each( function(){
        if($(this).hasClass('active')){
          $(this).parent().addClass('active');
        }
      });

      $('.dropdown-toggle').click(function() {
        $('.dropdown-content').removeClass('active');
        $(this).next().toggleClass('active');    
        return false;              
      });   
    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {
      $(".block-category.ajax a").click(function(e) {
        if (!$(this).hasClass('active')) {
          delete Shopify.queryParams.q;
          collection.filterAjaxClick($(this).attr('href'));
          $(".block-category.ajax a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },

    fillterTagEvents: function() {
      $('.filter-tag a:not(".clear"), .filter-tag label').click(function(e) {           
        var checkTag = location.pathname.split('/')[3];
        if (checkTag) {
          var currentTags = [checkTag];
        } else {
          var currentTags = [];
        }

        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');     
        }  

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {  
          var otherTag = $(this).parents('.filter-tag').find("input:checked");
          if (otherTag.length > 0) {
            var tagName = otherTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {           
                currentTags.splice(tagPos, 1);
              }
            }
          }          
        }

        var tagName = $(this).prev().val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {            
            currentTags.splice(tagPos, 1);
          } else {
            currentTags.push(tagName);
          }
        }
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
      $('.refined-widgets a.clear-all').click(function(e) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show().click(function(e) {    
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick();
            e.preventDefault();
          });
        }
      });
    }, 

    filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },    

    filterMapEvents: function() {
      collection.fillterTagEvents();
      collection.filterCategories();
    },

    resetFilter: function() {
      $(".filter-custom .active, .filter-links .active").removeClass("active");
      $(".filter-tag input:checked").attr("checked", false);

      //category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".filter-links a[href='" + cat[0] + "']").addClass("active");
      }
    },

    filterMapData: function(data) {
      var currentList = $(".collection-grid");
      if (currentList.length == 0) {
        currentList = $(".collection-list");
      }

      var productList = $(data).find(".collection-grid");
      if (productList.length == 0) {
        productList = $(data).find(".collection-list");
      }
      if (productList.length > 0 && productList.hasClass("products-grid")) {
        if (window.product_image_resize) {
          productList.find('img').fakecrop({
            fill: window.images_size.is_crop,
            widthSelector: ".products-grid .grid-item .product-image",
            ratioWrapper: window.images_size
          });
        }
      }
      currentList.replaceWith(productList);


      //replace view count
      if ($(".view-count").length > 0) {
        $(".view-count").replaceWith($(data).find(".view-count"));
      };
      
      //replace paging
      if ($(".padding").length > 0) {
        $(".padding").replaceWith($(data).find(".padding"));
      };

//       $(".filter-block").replaceWith($(data).find(".filter-block"))
    },

    filterCreateUrl: function(baseLink) {
      var checkTag = location.pathname.split('/')[3];
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      
      if (checkTag) {
        return location.pathname.replace(checkTag, "") + "?" + newQuery;
      } else {
        return location.pathname + "?" + newQuery;
      }
    },       

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;  
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams  
      }, newurl, newurl);
      collection.filterGetContent(newurl);         
    },        

    filterGetContent: function(newurl) {

      $.ajax({
        type: 'get',
        url: newurl, 
        beforeSend: function() {    
          showPopup('.loading'); 
        },

        success: function(data) {
          collection.filterMapData(data);               
           
          collection.filterMapClear();
          collection.filterMapClearAll();      

          collection.filterMapEvents(); 
          
           $('[data-toggle="tooltip"]').tooltip();

//           collection.initPaging();
          collection.initToggle();
         
          initWishlist();
          initAddToCart();
          productQT();
          hidePopup('.loading'); 

        }, 

        error: function(xhr, text) {
          hidePopup('.loading')
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }

      });
    },
    
    

    initCollectionFilter: function() {
      if ($(".collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
     
     
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();     
        if (!$(this).parent().hasClass("active")) {   
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();          

          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }    
        var selected = $(this).text();   
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');  

      });
    },


    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {
      $(".view-mode a").click(function(e) {
        if (!$(this).hasClass("active")) {
          var paging = $(".collection-show .dropdown-label").text();
          if ($(this).hasClass("list")) {
            Shopify.queryParams.view = "list" + paging;
          } else {
            Shopify.queryParams.view = paging;
          }

          collection.filterAjaxClick();
          $(".view-mode a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },

    
  

    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {   
      $(".collection-show a").click(function(e) {  
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          var currentPage = $(this).attr('href'); 
          var view = $(".view-mode a.active").attr("data-mode");       
          if (view == "list") {
            Shopify.queryParams.view = "list" + currentPage;
          } else {
            Shopify.queryParams.view = currentPage;
          }
          collection.filterAjaxClick();
          $(".collection-show li.active").removeClass("active");
          $(this).parent().addClass("active");
          $(this).closest('.dropdown').find('.dropdown-label').text(currentPage);
          $(this).closest('.dropdown-content').removeClass('active');  
        }
      });
    },

    /* --------------------------------------------------------- */
    /* Paging */
//     initPaging: function() {
//       $(".pagination a").click(function(e) {
//         var page = $(this).attr("href").match(/page=\d+/g); 
//         if (page) {
//           Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
//           if (Shopify.queryParams.page) {
//             var newurl = collection.filterCreateUrl();
//             collection.fillterClick = true;
//             History.pushState({
//               param: Shopify.queryParams
//             }, newurl, newurl);
//             collection.filterGetContent(newurl);
//             //go to top
//             $('body,html').animate({
//               scrollTop: 0
//             }, 600);

//           }
//         }
//         e.preventDefault();
//       });
//     },

  }

  function productQT(){

      var product = $('.product'),
          make3d = $(".make3D");

      $( window ).load(function() {
        var win =$(window).width(),
            full = product.parent();

        if (win > 479) {
          productchange();
        }
        else {
          $('.largeGrid').removeClass('active');
          full.removeClass('full-width');
          product.removeClass('engo-product-list');
          product.addClass('engo-product-grid')
          $('div.product').removeClass('large');
          make3d.removeClass('animate');
          make3d.removeClass('flip180');
          product.removeClass('large');
        }
        $(window).on('resize', function(){
          var win = $(this).width();
          if (win > 479) {
            productchange();
          }
          else {
            $('.largeGrid').removeClass('active');
            full.removeClass('full-width');
            product.removeClass('engo-product-list');
            product.addClass('engo-product-grid');
            $('div.product').removeClass('large');
            make3d.removeClass('animate');
            make3d.removeClass('flip180');
            make3d.removeClass('large');
          }
        });
      });
      function productchange(){
        var product = $('.product'),
            full = product.parent();
        $(".largeGrid").on('click',function(e){
          if (!($(this).hasClass('active'))) {
            $(this).addClass('active');
            $('.smallGrid').removeClass('active');
            full.addClass('full-width');
            product.removeClass('engo-product-grid')
            product.addClass('engo-product-list');
            $('.product').addClass('large').each(function(){
            });
            setTimeout(function(){
              $('.info-large').show();
            }, 200);
            setTimeout(function(){

              $('.view_gallery').trigger("click");
            }, 400);

            return false;
          }
          e.preventDefault();
        });

        $(".smallGrid").on('click',function(e){
          if (!($(this).hasClass('active'))) {
            $(this).addClass('active');
            $('.largeGrid').removeClass('active');
            full.removeClass('full-width');
            product.removeClass('engo-product-list');
            product.addClass('engo-product-grid')
            $('div.product').removeClass('large');
            $(".make3D").removeClass('animate');
            $('.info-large').fadeOut("fast");
            setTimeout(function(){
              $('div.flip-back').trigger("click");
            }, 400);
            $('.product').removeClass('large');
            return false;
          }
          e.preventDefault();
        });
      }
      //$(".smallGrid").click(function(){
      //
      //	return false;
      //});
      $('.colors-large a').on('click',function(){return false;});


      product.each(function(i, el){
        var win = $(window).width();
        if (win >= 992 ) {
          $(el).find('.make3D').hover(function(){
            $(this).parent().css('z-index', "20");
            $(this).addClass('animate');
            $(this).find('div.arrowNext, div.arrowPrev').addClass('visible');
          }, function(){
            $(this).removeClass('animate');
            $(this).parent().css('z-index', "1");
            $(this).find('div.arrowNext, div.arrowPrev').removeClass('visible');
          });
        }
        // Lift card and show stats on Mouseover

        // Flip card to the back side
        $(el).find('.view_gallery').on('click',function(e){

          $(el).find('div.arrowNext, div.arrowPrev').removeClass('visible');
          $(el).find('.make3D').addClass('flip-10');
          setTimeout(function(){
            $(el).find('.make3D').removeClass('flip-10').addClass('flip90').find('div.shadow').show().fadeTo( 80 , 1, function(){
              $(el).find('.product-front, .product-front div.shadow').hide();
            });
          }, 50);

          setTimeout(function(){
            $(el).find('.make3D').removeClass('flip90').addClass('flip190');
            $(el).find('.product-back').show().find('div.shadow').show().fadeTo( 90 , 0);
            setTimeout(function(){
              $(el).find('.make3D').removeClass('flip190').addClass('flip180').find('div.shadow').hide();
              setTimeout(function(){
                $(el).find('.make3D').css('transition', '100ms ease-out');
                $(el).find('.cx, .cy').addClass('s1');
                setTimeout(function(){$(el).find('.cx, .cy').addClass('s2');}, 100);
                setTimeout(function(){$(el).find('.cx, .cy').addClass('s3');}, 200);
                $(el).find('div.arrowNext, div.arrowPrev').addClass('visible');
              }, 100);
            }, 100);
          }, 150);
          e.preventDefault();
        });

        // Flip card back to the front side
        $(el).find('.flip-back').on('click',function(e){

          $(el).find('.make3D').removeClass('flip180').addClass('flip190');
          setTimeout(function(){
            $(el).find('.make3D').removeClass('flip190').addClass('flip90');

            $(el).find('.product-back div.shadow').css('opacity', 0).fadeTo( 100 , 1, function(){
              $(el).find('.product-back, .product-back div.shadow').hide();
              $(el).find('.product-front, .product-front div.shadow').show();
            });
          }, 50);

          setTimeout(function(){
            $(el).find('.make3D').removeClass('flip90').addClass('flip-10');
            $(el).find('.product-front div.shadow').show().fadeTo( 100 , 0);
            setTimeout(function(){
              $(el).find('.product-front div.shadow').hide();
              $(el).find('.make3D').removeClass('flip-10').css('transition', '100ms ease-out');
              $(el).find('.cx, .cy').removeClass('s1 s2 s3');
            }, 100);
          }, 150);
          e.preventDefault();

        });

        makeCarousel(el);
      });



      function makeCarousel(el){


        var carousel = $(el).find('.carousel ul');
        var carouselSlideWidth = carousel.children("li").outerWidth();
        var carouselWidth = 0;
        var isAnimating = false;
        var currSlide = 0;
        $(carousel).attr('rel', currSlide);

        // building the width of the casousel
        $(carousel).find('li').each(function(){
          carouselWidth += carouselSlideWidth;
        });
        $(carousel).css('width', carouselWidth);

        // Load Next Image
        $(el).find('div.arrowNext').on('click', function(){
          var currentLeft = Math.abs(parseInt($(carousel).css("left")));
          var newLeft = currentLeft + carouselSlideWidth;
          if(newLeft == carouselWidth || isAnimating === true){return;}
          $(carousel).css({'left': "-" + newLeft + "px",
                           "transition": "300ms ease-out"
                          });
          isAnimating = true;
          currSlide++;
          $(carousel).attr('rel', currSlide);
          setTimeout(function(){isAnimating = false;}, 300);
        });

        // Load Previous Image
        $(el).find('div.arrowPrev').on('click', function(){
          var currentLeft = Math.abs(parseInt($(carousel).css("left")));
          var newLeft = currentLeft - carouselSlideWidth;
          if(newLeft < 0  || isAnimating === true){return;}
          $(carousel).css({'left': "-" + newLeft + "px",
                           "transition": "300ms ease-out"
                          });
          isAnimating = true;
          currSlide--;
          $(carousel).attr('rel', currSlide);
          setTimeout(function(){isAnimating = false;}, 300);
        });
      }

      $('.sizes a span, .categories a span').each(function(i, el){
        $(el).append('<span class="x"></span><span class="y"></span>');

        $(el).parent().on('click', function(){
          if($(this).hasClass('checked')){
            $(el).find('.y').removeClass('animate');
            setTimeout(function(){
              $(el).find('.x').removeClass('animate');
            }, 50);
            $(this).removeClass('checked');
            return false;
          }

          $(el).find('.x').addClass('animate');
          setTimeout(function(){
            $(el).find('.y').addClass('animate');
          }, 100);
          $(this).addClass('checked');
          return false;
        });
      });

    }


  })(jQuery);